import { useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { NavigationItem, NavigationType } from "../Header";
import { NavbarDropdownMenu } from "./NavbarDropdownMenu";

export type Props = {
  id: ID;
  navigationName: string;
  dropdownMenu: Array<{
    id?: ID;
    title?: string;
    dropdownMenuPages: Array<NavigationItem>;
  }> | null;
  navigationUrl: string;
  type: NavigationType;
  dropdownPosition?: "left" | "right" | "center";
  currentNavlink: string;
  onNavlinkClick: (url: string, id: number) => void;
  playerId?: string | null;
  clickHeaderSub: (targetUrl: string) => void;
  dataTestId?: string;
};

export const NavbarItem: FC<Props> = ({
  id,
  navigationName,
  dropdownMenu,
  navigationUrl,
  type,
  dropdownPosition,
  currentNavlink,
  onNavlinkClick,
  clickHeaderSub,
  dataTestId,
}) => {
  const isActive =
    currentNavlink === navigationUrl + id &&
    (currentNavlink.includes(
      location.pathname === "/" ? "home" : location.pathname,
    ) ||
      location.pathname.includes(navigationUrl));

  const { Link } = useUiKitComponents();

  return (
    <div className="navbar-item" data-testid={dataTestId}>
      {type !== "jackvip" && type !== "jackpass" && type !== "leaderboard" && (
        <div
          className={`navbar-item-content 
          ${isActive && "active"} 
          ${type === "vip" && "navbar-item-content-vip"}`}
        >
          <div className="navbar-item-title-wrapper">
            <Link
              onClick={() => onNavlinkClick(navigationUrl, +id)}
              href={navigationUrl || "/"}
              className={`
              ${type === "vip" && "navbar-item-title-vip"} 
              navbar-item-title base-body2-text`}
              data-testid="header-navigation-link"
            >
              {navigationName}
            </Link>
            {dropdownMenu && type !== "default" && (
              <div className={`navbar-menu-wrapper ${dropdownPosition}`}>
                <NavbarDropdownMenu
                  navigationName={navigationName}
                  data={dropdownMenu}
                  clickHeaderSub={clickHeaderSub}
                />
              </div>
            )}
          </div>
          {dropdownMenu && type !== "default" && (
            <svg
              width="24"
              className="navbar-item-icon"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.79289 9.04289C7.18342 8.65237 7.81658 8.65237 8.20711 9.04289L12 12.8358L15.7929 9.04289C16.1834 8.65237 16.8166 8.65237 17.2071 9.04289C17.5976 9.43342 17.5976 10.0666 17.2071 10.4571L12.7071 14.9571C12.3166 15.3476 11.6834 15.3476 11.2929 14.9571L6.79289 10.4571C6.40237 10.0666 6.40237 9.43342 6.79289 9.04289Z"
                fill="white"
                fillOpacity="0.5"
              />
            </svg>
          )}
        </div>
      )}

      {type === "jackpass" && (
        <div className="navbar-item-jackpass">
          <Link
            href={navigationUrl || "/"}
            onClick={() => onNavlinkClick(navigationUrl, +id)}
            className="navbar-item-content-jackpass"
          >
            {navigationName}
          </Link>
        </div>
      )}

      {type === "jackvip" && (
        <div className="navbar-item-vip">
          <div className="navbar-item-vip-icon" />
          <Link
            href={navigationUrl || "/"}
            onClick={() => onNavlinkClick(navigationUrl, +id)}
            className="navbar-item-content-vip"
          >
            {navigationName}
          </Link>
          <div className="navbar-item-vip-icon" />
        </div>
      )}

      {type === "leaderboard" && (
        <Link
          className="navbar-item-leaderboard"
          href={navigationUrl || "/"}
          onClick={() => onNavlinkClick(navigationUrl, +id)}
        >
          {navigationName}
        </Link>
      )}
    </div>
  );
};
